import Vue from 'vue'
import App from './App.vue'
import { router } from './router'
import i18n from './vendors/i18n/i18n'
import Vuelidate from "./vendors/vue-validate"
import { ACL } from "./security/acl";

Vue.config.productionTip = false
Vue.use(Vuelidate)

ACL
  .getCurrentAuthorizedPath()
  .then(url => location.replace(url))
  .catch(() => new Vue({
    el: '#app',
    router,
    i18n,
    render: h => h(App)
  }));
